// Where the tutorial's hand is during its loop. Pure, for testing; the
// component turns this into a transform every frame.

export const LOOP_MS = { tap: 1600, drag: 2400, swipe: 2200 };

const ease = (t) => t * t * (3 - 2 * t);
const lerp = (a, b, t) => ({ x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t });

/**
 * The hand at time `ms` into the loop: where it points (x, y), how pressed it
 * is (0..1: a tap or a grab), and how visible (it fades between loops).
 * `from` is the target's middle, `to` where a drag ends, `width` the target's
 * width (a swipe goes across it).
 */
export const handAt = ({ gesture, from, to, width = 100, ms }) => {
  const loop = LOOP_MS[gesture] ?? LOOP_MS.tap;
  const t = (ms % loop) / loop;
  const fade = Math.min(1, t / 0.08, (1 - t) / 0.08);
  if (gesture === "drag" && to) {
    if (t < 0.2) return { ...from, press: ease(t / 0.2), fade };
    if (t < 0.75) return { ...lerp(from, to, ease((t - 0.2) / 0.55)), press: 1, fade };
    return { ...to, press: 1 - ease(Math.min(1, (t - 0.75) / 0.12)), fade };
  }
  if (gesture === "swipe") {
    const reach = Math.max(60, width * 1.6);
    return { x: from.x + Math.sin(t * Math.PI * 2) * reach, y: from.y, press: 0.4, fade };
  }
  // tap: drop in, press twice, lift
  const press = t > 0.3 && t < 0.42 ? 1 : t > 0.52 && t < 0.64 ? 1 : 0;
  return { x: from.x, y: from.y - (1 - ease(Math.min(1, t / 0.3))) * 26, press, fade };
};
